import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useAppointmentAPI } from 'apiServices/appointmentAPI';
import { useUserContext } from 'store';

const initialState = [
  {
    CNES: '0010510',
    organization: 'Hospital Universitário de Brasília',
    datetime: '2022-11-17T20:25Z',
    link: 'link',
  },
  {
    CNES: '0010510',
    organization: 'Hospital Universitário de Brasília',
    datetime: '2022-11-17T20:25Z',
  },
  {
    CNES: '0010510',
    organization: 'Hospital Universitário de Brasília',
    datetime: '2022-11-17T20:25Z',
  },
  {
    CNES: '0010510',
    organization: 'Hospital Universitário de Brasília',
    datetime: '2022-11-17T20:25Z',
  },
  {
    CNES: '0010510',
    organization: 'Hospital Universitário de Brasília',
    datetime: '2022-11-17T20:25Z',
  },
];

export const TeleconsultingContext = createContext(initialState);

export function TeleconsultingContextProvider({ children }) {
  const [user] = useUserContext();
  const [appointment, , loadingAppointment] = useAppointmentAPI({
    resourceId: user.cpf || user.cns,
  });

  function compareDates(date) {
    const actualDate = new Date(Date.now());
    // const actualDate = new Date('2022-12-02T10:02:45.000-03:00');
    const dateToCompare = new Date(date);

    const dateToCompareYear = dateToCompare.getFullYear();
    const dateToCompareMonth = dateToCompare.getMonth();
    const dateToCompareDay = dateToCompare.getUTCDate();
    const dateToCompareHour = dateToCompare.getHours();
    const dateToCompareMinutes = dateToCompare.getMinutes();

    const actualDateYear = actualDate.getFullYear();
    const actualDateMonth = actualDate.getMonth();
    const actualDateDay = actualDate.getUTCDate();
    const actualDateHour = actualDate.getHours();
    const actualDateMinutes = actualDate.getMinutes();

    const verifyYear = actualDateYear === dateToCompareYear;
    const verifyMonth = actualDateMonth === dateToCompareMonth;
    const verifyDay = actualDateDay === dateToCompareDay;
    // const verifyHour = actualDateHour === dateToCompareHour;
    // const verifyMinutes = actualDateMinutes === dateToCompareMinutes;

    let active = false;

    if (verifyYear && verifyMonth && verifyDay) {
      const checkHour = actualDateHour - dateToCompareHour;
      const checkMinutes = actualDateMinutes - dateToCompareMinutes;
      if (checkHour === -1 && dateToCompareMinutes === 0 && checkMinutes >= 30) active = true;
      if (checkHour === 0 && dateToCompareMinutes === 30) active = true;
      if (checkHour === 0 && checkMinutes < 30) active = true;
      if (checkHour === 0 && dateToCompareMinutes === 0 && checkMinutes >= 15) active = false;
      if (checkHour === 0 && dateToCompareMinutes === 30 && checkMinutes >= 15) active = false;
    }

    return active;
  }

  const contextValue = {
    initialState,
    appointment,
    loading: loadingAppointment,
    compareDates,
  };
  return (
    <TeleconsultingContext.Provider value={contextValue}>
      {children}
    </TeleconsultingContext.Provider>
  );
}

export function useTeleconsultingContext() {
  return useContext(TeleconsultingContext);
}

TeleconsultingContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
